/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { Fragment, useRef } from 'react'
import InputBox from '../../components/InputBox'
import ErrorMessage from '../../components/ErrorMessage'
import TextArea from '../../components/TextArea'
import { useCallback } from 'react'
import Debounce from '../../CommonMethods/Debounce'
import TopHeader from '../../components/TopHeader'
import { useState, useContext, useEffect } from 'react'
import { useNavigate, useParams, useLocation,useSearchParams} from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import GlobalContext from '../../components/Context/GloablContext'
import { Link } from 'react-router-dom'
import { validateEmail } from '../../CommonMethods/EmailValidator'
import { useAddProviderMutation, useEditProviderMutation, useViewProviderQuery,useLazyGetPatientAssociatedProviderQuery, useGetOrganizationsQuery,useLinkProvidertoOrganizationMutation, useLazyGetAssociatedOrganizationsQuery, useLazyGetSubdivisionsQuery, useDeleteAssociatedOrganizationMutation, useDeletePatientAssociatedToProviderMutation,useLazyViewProviderQuery } from '../../features/providerSlice'
import CustomOverLay from '../../components/CustomOverLay'
import { motion } from 'framer-motion'
import AnimatedModel from '../../components/Animation/AnimatedModel'
import Loader from '../../components/Loader'
import { handleIsAPICall } from '../../redux/commonSlice'
import ConfirmationPrompt from '../../components/ConfirmationPrompt'
import ProviderOrganizationAssocaition from './Components/ProviderOrganizationAssocaition'
import { phoneCodeArray } from '../../CommonMethods/phoneNumberCountryCodes'
import ProviderPatientList from './Components/PatientList'
import PhoneNumberValidator from '../../components/PhoneNumberInput'
import { useUpdateEmailMutation } from '../../features/apiSlice'
import { handleEditMessageSent,handleTargetUserEditId } from '../../redux/systemConfigSlice'
import { userService } from '../../services/user.services'
import { broadcastForcedLogout } from '../../CommonMethods/authSession'
import HelpGuideModal from '../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../features/patientSlice'
import PatientAssociatedList from '../ManageMonitorUser/Components/AssociatPatient'
import PatientAssociatedListProvider from './Components/AssociatPatient'
    

function AddProvider({ edit }) {
    const [addProvider] = useAddProviderMutation()
    const [editProvider] = useEditProviderMutation()
    const location = useLocation();
    const [patientAssociatedTrigger,patientAssociatedResult]=useLazyGetPatientAssociatedProviderQuery()
    const [addProviderDetails, setaddProviderDetails] = useState({
        "user_name": "",
        "first_name": "",
        "last_name": "",
        "email_address": "",
        "mobile_number": "",
        "main_number": "",
        "npi_number": "",
        "provider_credential": "Physician",
        "address": "",
        "contact_name": "",
        "billing_mobile_number": "",
        "fax": "",
        "billing_email_address": ""
    })
    const { id, user_id } = useParams()
    const [skip, setSkip] = useState(true)
    const { data, isFetching, status } = useViewProviderQuery(id, { skip: skip })
    const [triggerprovider,resultprovider] = useLazyViewProviderQuery()
    const [confirmationState, setConfirmationState] = useState(false)
    const [confirmationStateCancel, setConfirmationStateCancel] = useState(false)
    const [isDisableCancel,setIsDisableCancel]=useState(true)
    const { setToastmessage, UpdateCall, setUpdateCall, setToastErrorMessage, isSideBar, Toastmessage,editSocket ,sendMessageToStartEditing,sendMessageToStopEditing} = useContext(GlobalContext)
  
    const [emptyField, setEmptyField] = useState(false)
    const [emailError, setEmailError] = useState({
        "email_error": false,
        "billing_email_error": false,
        "username_error": false,
        "text":false
    })
    const [orgDetails,setOrgDetails]=useState({});
    const [nextTarget, setNextTarget] = useState('');
    const [loading, setLoading] = useState(false)
    const [deleteLoading ,setdeleteLoading]=useState(false)
    const navigate = useNavigate()
    const country_code = useSelector((state) => state?.systemConfigData?.globalVariables?.country_code?.split("-")[0])
    const [countryCodeVal, setCountryCodeVal] = useState('')
    const [countryCodeVal2, setCountryCodeVal2] = useState('')
    const [countryCodeVal3, setCountryCodeVal3] = useState('')
    const [countryCodeVal4, setCountryCodeVal4] = useState('')
    const [statusToggle, setStatusToggle] = useState(false)
    // Master switches (true = blocked, false = allowed). For new users default should be OFF (false).
    const [blockEmail, setBlockEmail] = useState(false)
    const [blockSms, setBlockSms] = useState(false)
    const [emptyArea, setEmptyArea] = useState(false);
    const [usernameError, setUsernameError] = useState(false)
    const [loadingStatus, setLoadingStatus] = useState(false)
    const [confirmationStateStatus,setConfirmationStateStatus]=useState(false)
    const [textAreaMsg,setTextAreaMsg]=useState('')
    const [deleteAssociatedProvider] = useDeletePatientAssociatedToProviderMutation()
    
    //  const [selectedValue, setSelectedValue] = useState('physician'); // Initialize with the default value
    const values = Object.values(addProviderDetails);
    // organization related states
    const [limit, setLimit] = useState("15")
    const [isOpen, setisOpen] = useState(false);
    const [isOpensub, setisOpensub] = useState(false);
    const [associatedsuccess, setassociatedsuccess] = useState(false);
    const [isColumnSelect, setIsColumnSelect] = useState(false);
    const [deleteModel, setDeleteModel] = useState(false);
    const [selectedRowtoDelete, setSelectedRowtoDelete] = useState({});
    const [linkOrganizationModel, setLinkOrganizationModel] = useState(false);
    const [isProviderAddOrDelete, setIsProviderAddOrDelete] = useState(false);

    const [submitSelected,setSubmitSelected]=useState(false);
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState({"mobile_number":true,"main_number":true,"billing_mobile_number":true,"fax":true});

    const [payload, setpayload] = useState({});
    const [searchParamsPatient,setSearchParamsPatient] = useSearchParams()
    const [searchParams, setSearchParams] = useState(`?page_number=1&limit=15&provider_id=${(data !== undefined && isFetching === 'fulfilled') && data.user_id}`);

    const [organizationListSearch, setOrganizationListSearch] = useState({
        page_number: 1,
        limit: 100,
    });
    const [selectedOrganizationName, setSelectedOrganizationName] = useState({
        organization_name: '',
        organization_id: '',
    });

    const [linkProvider] = useLinkProvidertoOrganizationMutation()

    const [deleteAssociatedOrganization] = useDeleteAssociatedOrganizationMutation()

    const [selectedSubdivisionName, setSelectedSubdivisionName] = useState([]);

    const [queryParamsOrg,setQueryParamsOrg] = useState('dropdown=true')
    const { data: organizationData, isFetching: organizationFetching } = useGetOrganizationsQuery(
        queryParamsOrg,  { refetchOnMountOrArgChange: true }
    );
    const [subTrigger, subresult, lastPromiseinfo1] = useLazyGetSubdivisionsQuery();
    const [trigger, result,lastPromiseinfo] = useLazyGetAssociatedOrganizationsQuery();
    const [changeProviderAccess,setChangeProviderAccess] = useState([])
    const [billingAgent,setBillingAgent] = useState([])
    const [sendAlert,setSendAlert] = useState([])
    const [isAnyFieldFilled,setIsAnyFieldFilled]=useState(false)
    const isFromEdit = location.state?.[1] || false;
    const originalListingState = Array.isArray(location.state) ? (location.state[0] ?? '') : (location.state ?? '')
    const [emailButtonLoading,setEmailButtonLoading]=useState(false)
    const [emailVefiedButton,setEmailVeriedButton]=useState(true);
    const [updateEmail] = useUpdateEmailMutation()
    // for edit multiple user
    const messageSent=useSelector(state=>state?.systemConfigData?.messageSent)
    const [dataloading,setDataLoading] = useState(true)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    const [queryParams,setQueryParams] = useState('?page_number=1&limit=15')
    const [pageItems,setPageItems]=useState('')
    
    const fetchPageAndLimitPat=()=>{
        const splitQuery = queryParams.split('?')[1];
        const params = new URLSearchParams(splitQuery); 
        return params
    }
    
    
    useEffect(() => {
        if (edit) {
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-edit-providers');
            } else {
                setQueryParamsadmin('type=admin-edit-providers');
            }
        } else {
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-add-providers');
            } else {
                setQueryParamsadmin('type=admin-add-providers');
            }
        }
    }, [userType,edit]);

    const handleGobackFn = () => {
        setSearchParamsPatient({}); // Update the state with the modified URLSearchParams object as a string
    };
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);


    const handleDeleteAssociatedOrganization = (item, index) => {
        setSelectedRowtoDelete(item)
        setDeleteModel(true)
    }

    const handleConfirmDelete = async () => {
        setdeleteLoading(true)
        const response = await deleteAssociatedOrganization({id:selectedRowtoDelete._id, userName:addProviderDetails.user_name})
        if (response?.error ) {
            setToastErrorMessage(response?.error?.data?.message)
            setDeleteModel(false)
            setdeleteLoading(false)
        } else{
            setToastmessage('Organization removed successfully')
            setDeleteModel(false)
            setdeleteLoading(false)
        }
    }

    const handleCloseDeleteModal = () => {
        setDeleteModel(false)
    }

    const handleCloseLinkModel = () => {
        setLinkOrganizationModel(false)
    }

    useEffect(() => {
        trigger(new URLSearchParams(searchParams)?.toString())
    }, [searchParams])

    const [totalPageNumber, setTotalPageNumber] = useState(1);
    
    const fetchPageAndLimit=()=>{
        const splitQuery = searchParams.split('?')[1];
        const params = new URLSearchParams(splitQuery); 
        return params
    }

    const handlePrevClick = () => {
        handleOnClickPageNumber(parseInt(fetchPageAndLimit().get("page_number")) - 1);
    };
    
    const handleNextClick = () => {
        handleOnClickPageNumber(parseInt(fetchPageAndLimit().get("page_number")) + 1);
    };
    const [isOpenLimit, setIsOpenLimit] = useState(false);

    function handleNoOfRowsClick(number) {
        const params = fetchPageAndLimit()
        setSearchParams(`${searchParams.split('?')[0]}?page_number=1&limit=${number}&provider_id=${data.user_id}`);
    }

    const handleOnClickPageNumber = (pageNum) => {
        const params = fetchPageAndLimit()
        setSearchParams(`${searchParams.split('?')[0]}?page_number=${pageNum}&limit=${params.get("limit")}&provider_id=${data.user_id}`);
    };

    const calculateTotalPages = (totalRecords, limit) => {
        return Math.ceil(totalRecords / limit);
    };

    useEffect(() => {
        
        const calculatedTotalPages = calculateTotalPages(result?.data?.total_count, fetchPageAndLimit().get("limit"));
        setTotalPageNumber(calculatedTotalPages);
    }, [result.data]);

    const handleChangeOrg=(value)=>{
        if(value!==''){
            setQueryParamsOrg(`search=${encodeURIComponent(value)}&dropdown=true`)
        }else{
            setQueryParamsOrg('dropdown=true')
        }
    }
    const handleOrganizationSearchTrigger=useCallback(
        Debounce((value)=>handleChangeOrg(value)),[]
    )

    // handle organization search
    const handleOrganizationListSearch = (value) => {
        setOrganizationListSearch((prevSearch) => {
            if (value !== '') {
                return {
                    ...prevSearch,
                    search: value,
                };
            } else {
            // Remove the search key from the state if the value is empty
                const { search, ...rest } = prevSearch;
                return rest;
            }
        });
        handleOrganizationSearchTrigger(value)
      
    };

    const handleChange=(val,id,user_id)=>{
        if(val.trim()!==''){
            subTrigger(`organization_id=${id}${val !== '' ? `&sub_division_name=${encodeURIComponent(val)}` : ""}&provider_id=${user_id}`)

        }else{
            subTrigger(`organization_id=${id}&provider_id=${user_id}`)
        }
        
    }

    const handleSubdivisionSearchTrigger=useCallback(
        
        Debounce((value,id,user_id)=>handleChange(value,id,user_id)),
        []

    )
    // handle subdivision search
    const handleSubdivisionListSearch = (value) => {
        setSelectedOrganizationName((prevSearch) => {
            if (value !== '') {
                return {
                    ...prevSearch,
                    sub_division_name: value,
                };
            } else {
            // Remove the search key from the state if the value is empty
                const { sub_division_name, ...rest } = prevSearch;
                return rest;
            }
        });
        handleSubdivisionSearchTrigger(value,selectedOrganizationName.organization_id,data?.user_id)
        //subTrigger(`organization_id=${selectedOrganizationName.organization_id}${value !== '' ? `&sub_division_name=${value}` : ""}&provider_id=${data.user_id}`)
        
    }

    const handleFetchSubdivision = (item) => {
        setSelectedOrganizationName((prevState) => ({
            ...prevState,
            organization_name: item.organization_name,
            organization_id: item.organization_id,
        }));
        subTrigger(`organization_id=${item.organization_id}&provider_id=${data.user_id}`);
        setisOpen(false);
        setSelectedSubdivisionName([]);
    };

    const handleSelectionSubdivision = (item) => {
        setSelectedSubdivisionName((prevState) => {
            const isSelected = prevState.some(subdiv => subdiv.subdivision_id === item.subdivision_id);
            if (isSelected) {
            // If the item is already selected, remove it
                return prevState.filter(subdiv => subdiv.subdivision_id !== item.subdivision_id);
            } else {
            // If the item is not selected, add it
                return [...prevState, item];
            }
        });
    
    };

    const handleAddAssociation = async () => {
       
        setdeleteLoading(true)
        const subdivisionIds = selectedSubdivisionName.map(item => item.subdivision_id);
        const body = {
            "organization_id": selectedOrganizationName.organization_id,
            "subdivision_id": subdivisionIds,
            "provider_id": data.user_id,
            "target_user_name": data.user_name,
        };
    
        setisOpensub(false);
        const response = await linkProvider(body)
        if(response?.data?.success_status === true) {
            setToastmessage(response?.data.message)
            setassociatedsuccess(true);
            setSelectedOrganizationName({
                organization_name: '',
                organization_id: '',
            });
            setSelectedSubdivisionName([])
            setLinkOrganizationModel(false)
            trigger(new URLSearchParams(searchParams)?.toString())
            setdeleteLoading(false)
        } else {
            setToastErrorMessage(response?.error?.data?.message);
            setassociatedsuccess(false);
            setisOpensub(false);
            setSelectedOrganizationName({});
            setSelectedSubdivisionName([])
            setLinkOrganizationModel(false)
            setdeleteLoading(false)
          
        }
    }

    const dispatch = useDispatch()

    function handleOnChangeUserDetails(id,option){
        setSubmitSelected(false)

        setEmailError((prevErrors) => ({
            ...prevErrors,
            username_error: false,
            email_error: false,
            billing_email_error: false,
            "text":false

        }));
        const fieldToUpdate = {
            user_name:"user_name",
            first_name:"first_name",
            last_name:"last_name",
            email_address:"email_address",
            mobile_number:"mobile_number",
            main_number:"main_number",
            address:"address",
            npi_number: "npi_number",
            contact_name: "contact_name",
            billing_mobile_number: "billing_mobile_number",
            fax: "fax",
            billing_email_address: "billing_email_address",
        }[id];
        
        const regex = /^[1-9]\d*$/;
        let sanitizedOption = option;
        let isValid=true
        if(id==="provider_credential"){
            setIsDisableCancel(false)
            setaddProviderDetails((prv) => ({
                ...prv,
                [id]: option,
            }));
        }
        if (id === "mobile_number"||id==="main_number" || fieldToUpdate==="npi_number" || fieldToUpdate === "billing_mobile_number" || fieldToUpdate === 'fax') {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid=false
            }
        }
        if(!isValid){
            if (fieldToUpdate) {
                setaddProviderDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption
                }));
            }             
            return
        }
        if(fieldToUpdate){

            setIsDisableCancel(false)
            if(fieldToUpdate==="admin"){
                setaddProviderDetails((prev) => ({
                    ...prev,
                    "admin": !addUserDetails.admin,
                }));
            }
            else if(fieldToUpdate==="mobile_number"||fieldToUpdate==="main_number" || fieldToUpdate==="npi_number" || fieldToUpdate === "billing_mobile_number" || fieldToUpdate === 'fax'){
                // Validation: Can't delete mobile number when SMS is enabled
                if(fieldToUpdate==="mobile_number" && option.trim() === "" && !blockSms){
                    setToastErrorMessage("Provider mobile number cannot be deleted while Master SMS Alert is enabled")
                    return
                }
                if(option.length<=20){
                    setaddProviderDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if(fieldToUpdate==="first_name"||fieldToUpdate==="last_name"){
                if(option.length<=30){
                    setaddProviderDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));

                }

            }
            else if(fieldToUpdate==="email_address"||fieldToUpdate==="user_name"|| fieldToUpdate==="billing_email_address"){
                setUsernameError(false)
                setEmailVeriedButton(true)
                setEmailButtonLoading(false)
                if(option.length<=80){
                    setaddProviderDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option.trim(),
                    }));
                }
            }
            else{
                setaddProviderDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
                
            }
            
        }
        
    }
    
    // handle view screen
    const handleNavigationToViewPage = () => {
        navigate(`/manage-provider/${id}`,  {state:originalListingState, provider_id:data?.user_id})
    }

    const handleOnAddUser = async () => {
        setLoading(true)
        try {
            setLoading(true)
            let response = null
            let body = {
                "user_name": addProviderDetails.user_name,
                "first_name": addProviderDetails.first_name,
                "last_name": addProviderDetails.last_name,
                // "email_address": addProviderDetails.email_address,
                "mobile_number": addProviderDetails.mobile_number,
                "main_number": addProviderDetails.main_number,
                "npi_number": addProviderDetails.npi_number,
                "provider_credential": addProviderDetails.provider_credential,
                "address": addProviderDetails.address,
                "billing_contact": {
                    "contact_name": addProviderDetails.contact_name,
                    "billing_mobile_number": addProviderDetails.billing_mobile_number,
                    "fax_country_code": "+" + (countryCodeVal4 !== "" ? countryCodeVal4.split('\t').join('') : country_code.split('\t').join('')),
                    "fax": addProviderDetails.fax,
                    "billing_email_address": addProviderDetails.billing_email_address,
                    "billing_mobile_no_country_code": "+" + (countryCodeVal3 !== "" ? countryCodeVal3.split('\t').join('')?.trim()  : country_code.split('\t').join('')?.trim() )
                },
                "mob_no_country_code": "+" + (countryCodeVal !== "" ? countryCodeVal.split('\t').join('')?.trim() : country_code.split('\t').join('')?.trim() ),
                "main_no_country_code": "+" + (countryCodeVal2 !== "" ? countryCodeVal2.split('\t').join('')?.trim()  : country_code.split('\t').join('')?.trim() )
            }
            // include master switches for both add + edit
            body["block_email"] = blockEmail
            body["block_sms"] = blockSms
            // edit provider
            if (edit) {
                if(changeProviderAccess?.length>0){
                    let providerUserObj = patientAssociatedResult?.data?.data?.map((patient)=>({patient_id:patient?.patient_id,
                        preference_mode:patient?.preference_mode,
                        send_alert:patient?.send_alert,
                        user_name:patient?.patientData?.user_name}))
                    let providerUserBody=changeProviderAccess?.map((val,index)=>({preference_mode:val,send_alert:sendAlert[index]}))
                    let finalproviderUserBody=providerUserObj.map((obj1,index) => {
                        const newObj = {};
                        Object.keys(obj1).forEach((key,value) => {
                            if(key==='patient_id'||key==='user_name'){
                                newObj[key]=obj1[key]
                            }
                            else if (providerUserBody[index][key]!==obj1[key]) {
                                newObj[key] = providerUserBody[index][key];
                            }
                        });
                        return newObj;
                    });
                    let filteredfinalproviderUserBody=finalproviderUserBody?.filter((obj)=>Object.keys(obj)?.length>2)
                    Array.isArray(filteredfinalproviderUserBody)&&filteredfinalproviderUserBody?.length>0?body.patients=filteredfinalproviderUserBody:[]
                }

                const editRes = await editProvider({ id, body})
                //dispatch(handleIsAPICall(true))
                if (editRes?.error?.data?.message) {
                    const errorMessage = editRes?.error?.data?.message
                    // Handle validation errors and revert state if needed
                    if (errorMessage?.includes("Master SMS Alert cannot be enabled")) {
                        setBlockSms(true) // Revert to previous state
                    } else if (errorMessage?.includes("cannot be deleted while Master SMS")) {
                        // Revert mobile number change - handled in onChange
                    }
                    setConfirmationState(false)
                    setToastErrorMessage(errorMessage)
                    setLoading(false)
                }
                else {
                    setConfirmationState(false)
                    navigate(`/manage-provider/${id}`,  {state:originalListingState, provider_id:data?.user_id})
                    setToastmessage('Provider details updated successfully');
                    setLoading(false)
            
                }
            }
            else {
                const addRes = await addProvider(body)
                //dispatch(handleIsAPICall(true))
                if (addRes?.error?.data?.message) {
                    setConfirmationState(false)
                    setToastErrorMessage(addRes?.error?.data?.message)
                    setLoading(false)
                    if (addRes?.error?.data?.message === "Username already exists. Please try another") {
                        setUsernameError(true)
                    }
                }
                else {
                    setConfirmationState(false)
                    navigate(`/manage-provider/${addRes?.data?.provider_id}`, {state:originalListingState})
                    setToastmessage(addRes?.data?.message);
                    setLoading(false)
                }
            }
        } catch (error) {
            setLoading(false);
            //dispatch(handleIsAPICall(true))
            setToastErrorMessage(error.message)
        }
    }

    useEffect(() => {
        if (edit) {
            setSkip(false)
        }
        if(id){
            triggerprovider(id)      
        }   
    }, [edit,id])

    useEffect(()=>{
        let hasLoggedOut = false;
        if (editSocket && !hasLoggedOut) {
            
            editSocket.onmessage = async (event) => {
                if (hasLoggedOut) {
                    return; // Prevent multiple logout calls
                }else if (event.data === "logout") {
                    hasLoggedOut = true;
                    await userService.DuplicateLogout();
                    let arcm_trust_browser_token = localStorage.getItem('arcm_trust_browser_token')
                    let LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs')
                    broadcastForcedLogout();
                    localStorage.clear();
                    sessionStorage.clear();
                    localStorage.setItem("arcm_trust_browser_token",arcm_trust_browser_token)
                    localStorage.setItem("LogoutfromAllTabs",LogoutfromAllTabs)
                    sessionStorage.setItem('showDuplicateSessionLogout', 'true');
                    setTimeout(() => {
                        window.location.reload();
                        navigate('/');
                    }, 500);
                }
            };
        }
    },[editSocket])

    // set value for edit provider
    useEffect(() => {
        if (resultprovider !== undefined && resultprovider?.data?.user_id!==undefined) {
            dispatch(handleTargetUserEditId(resultprovider?.data?.user_id))
            if(edit&&!messageSent&&editSocket){
               
                sendMessageToStartEditing(resultprovider?.data?.user_id)
                let message
                editSocket.onmessage = (event) =>{
                    message = event.data
                    if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                        setDataLoading(false)
                    } else{
                        dispatch(handleEditMessageSent(false))
                        navigate('/manage-provider', {state: originalListingState})
                        { (JSON.parse(message)?.adminId) &&
                            setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this provider`)
                        }
                    
                    }
                }    
            }else{
                setDataLoading(false)
            }
            setaddProviderDetails((prev) => ({
                ...prev,
                "user_name": resultprovider?.data?.user_name,
                "first_name": resultprovider?.data?.first_name,
                "last_name": resultprovider?.data?.last_name,
                "email_address": resultprovider?.data?.email_address,
                "mobile_number": resultprovider?.data?.mobile_number,
                "main_number": resultprovider?.data?.main_number,
                "npi_number": resultprovider?.data?.npi_number,
                "provider_credential": resultprovider?.data?.provider_credential,
                "address": resultprovider?.data?.address,
                "contact_name": resultprovider?.data?.billing_contact.contact_name,
                "billing_mobile_number": resultprovider?.data?.billing_contact.billing_mobile_number,
                "fax": resultprovider?.data?.billing_contact.fax,
                "billing_email_address": resultprovider?.data?.billing_contact.billing_email_address,
            }))
            setSearchParams((prevParams) => `?page_number=1&limit=15&provider_id=${resultprovider?.data?.user_id}`);
            setStatusToggle(resultprovider?.data?.status === "inactive" ? false : true)
            // Initialize block_email and block_sms from API response, default to false if not present
            const blockEmailValue = resultprovider?.data?.block_email ?? resultprovider?.data?.userDetails?.block_email
            const blockSmsValue = resultprovider?.data?.block_sms ?? resultprovider?.data?.userDetails?.block_sms
            setBlockEmail(blockEmailValue !== undefined ? blockEmailValue === true : false)
            setBlockSms(blockSmsValue !== undefined ? blockSmsValue === true : false)
            setSkip(true)
            if(resultprovider?.data && edit){
                setCountryCodeVal(resultprovider?.data?.mob_no_country_code.split('+')[1])
                setCountryCodeVal2(resultprovider?.data?.main_no_country_code.split('+')[1])
                setCountryCodeVal3(resultprovider?.data?.billing_contact.billing_mobile_no_country_code .split('+')[1])
                setCountryCodeVal4(resultprovider?.data?.billing_contact.fax_country_code .split('+')[1])
                patientAssociatedTrigger(`?user_id=${resultprovider?.data?.user_id}&page_number=1&limit=15`)
            }
        }
        return(()=>{
            if((location.state===null || location.state==='')){
                sendMessageToStopEditing(resultprovider?.data?.user_id)
            }  
        })
    }, [resultprovider])

    const handleConformationClick = () => {
        setEmptyArea(false)
        setConfirmationState(false);
    }

    const handleConformationClickCancel = () => {
        setEmptyArea(false)
        
        setConfirmationStateCancel(false);
    }

    const handleSubmit = () => {
        setSubmitSelected(true)

        const hasEmptyFields = () => {
            let isFieldsEmpty = false
            if (addProviderDetails?.first_name.trim() === "" || 
                addProviderDetails?.main_number.trim() === "" || 
                addProviderDetails?.user_name.trim() === "" || 
                addProviderDetails?.last_name.trim() === "" || 
                addProviderDetails?.mobile_number.trim() === "" ||
                addProviderDetails?.main_number.trim() === "" ||
                (edit && addProviderDetails?.email_address?.trim() === "")
            ) {
                isFieldsEmpty = true
            }
            // return (!addProviderDetails.admin&&areFieldsEmpty) || isFieldsEmpty;
            return isFieldsEmpty
        };
        if (hasEmptyFields()) {
            setLoading(false)
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");
            return;
        }
        if (validateEmail(addProviderDetails?.user_name?.trim())) {
            setEmailError((prev) => ({
                ...prev,
                "username_error": true,
                "text":true

            }))
            if (addProviderDetails?.email_address?.trim() !== "" && validateEmail(addProviderDetails?.email_address?.trim())) {
                setEmailError((prev) => ({
                    ...prev,
                    "email_error": true,
                    "text":true

                }))
            }
            setLoading(false)
            return
        }
        if (addProviderDetails?.email_address?.trim() !== "" && validateEmail(addProviderDetails?.email_address?.trim())) {
            setEmailError((prev) => ({
                ...prev,
                "email_error": true,
                "text":true

            }))
            setLoading(false);
            return
        }
        if (addProviderDetails?.billing_email_address?.trim() !== "" && validateEmail(addProviderDetails?.billing_email_address?.trim())) {
            setEmailError((prev) => ({
                ...prev,
                "billing_email_error": true,
                "text":true
            }))
            setLoading(false);
            return
        }
        if ((!(isPhoneNumberValid.main_number)&&addProviderDetails?.main_number!=='') || (!(isPhoneNumberValid.mobile_number)&&addProviderDetails?.mobile_number!=='') || (!(isPhoneNumberValid.billing_mobile_number)&&addProviderDetails?.billing_mobile_number!=='') || (!(isPhoneNumberValid.fax)&&addProviderDetails?.fax!=='')) {
            setLoading(false);
            return;
        }
        else {
            setConfirmationState(true)
        }
    }

    const handleCancel = () => {
        setaddProviderDetails('');
        if (nextTarget === 'view') {
            navigate(`/manage-provider/${id}`, {state: originalListingState});
        } else {
            navigate('/manage-provider', {state: originalListingState});
        }
    }

    const handleCancelBottom = () => {
        if (isDisableCancel && (isFromEdit===true)) {
            navigate(`/manage-provider/${id}`, {state: originalListingState});
        } else if (isDisableCancel) {
            navigate('/manage-provider',{state:originalListingState});
        } else {
            setNextTarget(
                (isFromEdit===true)
                    ? 'view'
                    : 'list'
            );
            setConfirmationStateCancel(true);
        }    
    }

    // handle the cancel button functionality
    const handleConformationClickStatus = () => {
        setEmptyArea(false)
        setStatusToggle(!statusToggle)
        setTextAreaMsg("")
        setConfirmationStateStatus(false);
    }

    const handleOnCLickChangeStatus = async(e) => {
        // useDispatch(handleIsAPICall(true))
        if(statusToggle===false&& textAreaMsg.trim()===""){ 
            setToastErrorMessage('Please fill in the mandatory field')
        
            setEmptyArea(true)
            
            return;
        }
        try {
            let body = { }
            if(statusToggle===false){
                body={
                    "user_name": [addProviderDetails.user_name],
                    "status":"inactive",
                    "note" : textAreaMsg 
                } 
            }
            else{
                body={
                    "user_name": [addProviderDetails.user_name],
                    "status":"active",
                    "note":''
                } 
            }
            
            setLoadingStatus(true)
            
            const activationRes=await editProvider({body})
            
            setLoadingStatus(false)
            
            if(activationRes.error){
                setToastErrorMessage(activationRes?.error?.data?.message)            
            }else{
                setToastmessage(`Provider ${statusToggle===true?"activated":"deactivated"} successfully`);
                
            }
            setConfirmationStateStatus(false);
            setTextAreaMsg('');
           
        } catch (error) {
            setConfirmationStateStatus(false);
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }  
    
    const handleDeleteAssociatedPatient = (item, index) => {
        setSelectedRowtoDelete(item)
        setIsProviderAddOrDelete(true)
    }
    const handleClosePatientDeleteModal = () => {
        setIsProviderAddOrDelete(false)
    }
    const handleConfirmPatientDelete = async (type) => {
        setdeleteLoading(true)
        let patient_id=selectedRowtoDelete?.patient_id
        let provider_id=data?.user_id
        let response = {}
        response = await deleteAssociatedProvider({patient_id,provider_id})
        if (response?.error ) {
            setToastErrorMessage(response?.error?.data?.message)
            setIsProviderAddOrDelete(false)
            setdeleteLoading(false)
           
        } else{
            setToastmessage(`Patient removed successfully`)
            setIsProviderAddOrDelete(false)
            setdeleteLoading(false)

            // Get the current page and limit
            const params = fetchPageAndLimitPat();
            let currentPage = parseInt(params.get("page_number")) || 1;
            let limit = parseInt(params.get("limit")) || 15;
                  
            // Only decrease the page number if the current page has only 1 item before deletion
            if (currentPage > 1 && parseInt(pageItems) === 1) {
                currentPage -= 1; // Move to the previous page
            }   
            // Update query params and re-fetch data
            setQueryParams(`?user_id=${resultprovider?.data?.user_id}&page_number=${currentPage}&limit=${limit}`);
            patientAssociatedTrigger(`?user_id=${resultprovider?.data?.user_id}&page_number=${currentPage}&limit=${limit}`);
        }
    
    }

    const handleOnVerifyEmail=async()=>{           
        if(addProviderDetails?.email_address?.trim()!==""&&validateEmail(addProviderDetails?.email_address?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "email_error":true,
                "text":true
            }))
            setLoading(false)
            return   
        }
        try {
            setEmailButtonLoading(true)
            let body={}
            body={
                "user_type":"provider",
                "email_address": addProviderDetails.email_address.trim().replace(/\s/g, ''),
            }
            const emailVerifyRes=await updateEmail({id,body})

            if(emailVerifyRes?.error?.data?.message==="Email Address must be a valid email address"){
                setEmailError((prev)=>({
                    ...prev,
                    "email_error":true,
                    "text":true
                })) 
                setEmailButtonLoading(false)
            }
            else if(emailVerifyRes?.error?.data?.message){
                setConfirmationState(false)
                setToastErrorMessage(emailVerifyRes?.error?.data?.message)
                setEmailError((prev)=>({
                    ...prev,
                    "email_error":true,
                    "text":false
                })) 
                setEmailButtonLoading(false)
            }
            else{
                setToastmessage(emailVerifyRes?.data?.message);
                setEmailButtonLoading(false)   
                setEmailVeriedButton(false)
            }
        } catch (error) {
            setLoading(false); 
            setToastErrorMessage(error.message)   
        }

    }
    useEffect(()=>{
        return(()=>{
         
            if(location?.state!==null||location?.state!==''){
          
                sendMessageToStopEditing()
            }
        })
       
    },[])

    

    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={`${edit ? 'Edit ' : 'Add '}Provider`} />
                {((edit && resultprovider?.isFetching && resultprovider?.status !== "fulfilled") ||(edit&&dataloading)) ? <CustomOverLay Active text="Loading Provider Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'system_config_overlay'}`} /> : <>
                    <div className='bg-white rounded-lg py-[12px] pl-[30px] pr-[10px] h-customh3'>
                        <motion.div
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className='bg-white'>
                                <div className='pr-7'>
                                    <div className='flex items-center mb-5'>
                                        <Link to="/manage-provider" state={originalListingState}>
                                            <h1 className="text-sm font-normal text-[#52555D]">Manage Provider</h1>
                                        </Link>
                                        {isFromEdit===true &&<>
                                            <span className='mx-2'><img loading='lazy' decoding='async' src="/images/breadcrumb-icon.svg" alt="icon"/></span>

                                            <Link to={`/manage-provider/${location.state?.[2]}`} state={originalListingState}>
                                                <h1 className="text-sm font-normal text-[#52555D]">View Provider</h1>
                                            </Link>
                                        </>}
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                        <h1 className="text-sm font-normal text-[#008586]">{`${edit ? 'Edit ' : 'Add '}Provider`}</h1>
                                        {
                                            userType !=='super-admin' &&
                                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                            </span> 
                                        }
                                    </div>
                                    {searchParamsPatient.get('view')!==null?<>
                                        <div onClick={() =>handleGobackFn()} className='flex cursor-pointer items-center'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Edit Provider</span>
                                        </div>
                                    </> :<>
                                        {isFromEdit===true ?
                                            <Link to={`/manage-provider/${location?.state?.[2]}`} state={originalListingState} className=' items-center min-w-max flex'>
                                                <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                                <span className='text-sm font-normal text-[#008586] pl-3'>Go back to View Provider</span>
                                            </Link> :
                                            <div onClick={handleCancelBottom} state={location.state} className='flex cursor-pointer items-center'>
                                                <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                                <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                            </div>
                                        }
                                        <h1 className='text-xl font-normal text-[#000000] w-full text-center mt-[-23px]'>
                                            {`${edit ? 'Edit ' : 'Add '}Provider`}
                                        </h1>
                                        <p className='text-end pt-3.5 pb-1'>‘*’ Indicates mandatory field</p>
                                    </>}
                                </div>
                                {searchParamsPatient.get('view')!==null?<PatientAssociatedListProvider
                                    orgDetails={orgDetails}
                                    providerId={data?.user_id}
                                />: <>
                                    <div className={`pr-5 h-customh16 overflow-auto overflow-x-hidden scrollbar_purple bg-white`}>
                                        <div className="border border-[#C5C9DA] rounded-lg px-6 2xl:px-[57px] py-6 mb-4">
                                            <div className='flex flex-wrap -mx-[18px]'>
                                                <div className={`w-1/3 px-[18px] ${emailError.username_error ? 'mb-[2px]' : 'mb-[32px]'}`}>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"Username*"}
                                                            placeholder={"Enter Username"}
                                                            id={"user_name"}
                                                            htmlFor={"Provider_Username"}
                                                            value={addProviderDetails.user_name}
                                                            disabled={edit === true ? true : false}
                                                            data_testid={"user_name"}
                                                            emailError={emailError.username_error}
                                                            usernameError={usernameError}
                                                            emptyField={emptyField && addProviderDetails?.user_name?.trim() === ""}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                        {emailError.username_error && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438] mt-2 '} message={"Invalid user name"} />}
                                                    </div>
                                                </div>
                                                <div className='w-1/3 px-[18px] mb-[32px]'>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"First Name*"}
                                                            placeholder={"Enter First Name"}
                                                            id={"first_name"}
                                                            data_testid={"first_name"}
                                                            htmlFor={"Provider_First_Name"}
                                                            value={addProviderDetails.first_name}
                                                            emptyField={emptyField && addProviderDetails?.first_name?.trim() === ""}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='w-1/3 px-[18px] mb-[35px]'>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"Last Name *"}
                                                            placeholder={"Enter Last Name"}
                                                            id={"last_name"}
                                                            data_testid={"last_name"}
                                                            htmlFor={"Provider_Last_Name"}
                                                            value={addProviderDetails.last_name}
                                                            emptyField={emptyField && addProviderDetails?.last_name?.trim() === ""}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                    </div>
                                                </div>
                                                {!edit && 
                                                <div className={`w-1/3 px-[18px] ${emailError.email_error ? 'mb-[2px]' : 'mb-[35px]'}`}>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"Email Address *"}
                                                            placeholder={"Enter Email Address"}
                                                            id={"email_address"}
                                                            data_testid={"email_address"}
                                                            htmlFor={"Provider_Email_Address"}
                                                            value={addProviderDetails.user_name}
                                                            emptyField={false}
                                                            disabled={true}
                                                            emailError={emailError.email_error}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                        {emailError.email_error && <ErrorMessage error message={"Invalid email address"} />}
                                                    </div>
                                                </div>
                                                }
                                                {edit && <>
                                                    <div className={`w-1/3 px-[18px] ${emailError.email_error ? 'mb-[2px]' : 'mb-[35px]'}`}>
                                                        <div className='w-full'>
                                                            <InputBox
                                                                label={"Email Address *"}
                                                                placeholder={"Enter Email Address"}
                                                                id={"email_address"}
                                                                data_testid={"email_address"}
                                                                htmlFor={"Provider_Email_Address"}
                                                                value={addProviderDetails.email_address}
                                                                emptyField={emptyField && addProviderDetails?.email_address?.trim() === ""}
                                                                emailError={emailError.email_error}
                                                                handleOnChangeInput={handleOnChangeUserDetails}
                                                            />
                                                            {emailError.email_error && <ErrorMessage error message={emailError?.text&&"Invalid email address"} />}
                                                        </div>
                                                    </div>
                                                    {( (resultprovider?.data?.email_address !== addProviderDetails?.email_address)) && 
                                                    <div className={`flex items-start gap-12 w-2/3 px-[18px] mb-[35px] pt-3.5`}>
                                                        <button type='button'
                                                            id="verify"
                                                            onClick={() => handleOnVerifyEmail()}
                                                            disabled={emailButtonLoading || !emailVefiedButton || addProviderDetails?.email_address?.trim()===""}
                                                            className={`px-4 py-2 text-lg flex items-center justify-center font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[170px]
                                                        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] disabled:cursor-not-allowed`}>
                                                            {!emailButtonLoading ? "Verify" : <span>{<Loader />}</span>}
                                                        </button>
                                                        <div className='flex-1'>
                                                            <p className='text-sm font-semibold text-[#000000] mb-3'>Block Active Alerts</p>
                                                            <div className='flex flex-row gap-4'>
                                                                <div className="status custom-toggle flex items-center">
                                                                    <label className="switch" style={{marginLeft: '0px'}}>
                                                                        <input
                                                                            type="checkbox"
                                                                            onChange={() => {
                                                                                const nextValue = !blockSms
                                                                                // Validation: can't allow SMS alerts (unblock) without a mobile number
                                                                                if (nextValue === false && (!addProviderDetails.mobile_number || addProviderDetails.mobile_number.trim() === "")) {
                                                                                    setToastErrorMessage("Master SMS Alert cannot be enabled without a mobile number")
                                                                                    return
                                                                                }
                                                                                setBlockSms(nextValue)
                                                                                setIsDisableCancel(false)
                                                                            }}
                                                                            checked={blockSms}
                                                                        />
                                                                        <span className="slider round"></span>
                                                                    </label>
                                                                    <p className="text-sm font-normal text-[#008586] disable_switch ml-3">
                                                                        SMS
                                                                    </p>
                                                                </div>
                                                                <div className="status custom-toggle flex items-center">
                                                                    <label className="switch" style={{marginLeft: '0px'}}>
                                                                        <input 
                                                                            type="checkbox" 
                                                                            onChange={(e) => {
                                                                                setBlockEmail(!blockEmail)
                                                                                setIsDisableCancel(false)
                                                                            }} 
                                                                            checked={blockEmail}
                                                                        />
                                                                        <span className="slider round"></span>
                                                                    </label>
                                                                    <p className="text-sm font-normal text-[#008586] disable_switch ml-3">
                                                                        Email
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }                
                                                    {((resultprovider?.data?.email_address === addProviderDetails?.email_address)) && 
                                                    <div className={`flex items-start gap-12 w-2/3 px-[18px] mb-[35px] pt-3`}>
                                                        <button type='button'
                                                            id="verified"
                                                            className={`px-4 py-2 flex items-center justify-center text-lg font-semibold text-[#000] rounded-[16px] mt-2.5 w-[170px] cursor-default
                                                                            bg-[#C5C9DA] disabled:bg-[#777C88] disabled:cursor-not-allowed`}>
                                                            <span className='w-6 h-6 bg-[#1A883C] rounded-[50%] mr-2.5 flex justify-center items-center'>
                                                                <img src="/images/success_toast.svg" alt="icon" loading='lazy'  className='w-3.5 h-3.5' decoding='async' />
                                                            </span>
                                                            Verified
                                                        </button>
                                                        <div className='flex-1'>
                                                            <p className='text-sm font-semibold text-[#000000] mb-3'>Block Active Alerts</p>
                                                            <div className='flex flex-row gap-4'>
                                                                <div className="status custom-toggle flex items-center">
                                                                    <label className="switch" style={{marginLeft: '0px'}}>
                                                                        <input
                                                                            type="checkbox"
                                                                            onChange={() => {
                                                                                const nextValue = !blockSms
                                                                                // Validation: can't allow SMS alerts (unblock) without a mobile number
                                                                                if (nextValue === false && (!addProviderDetails.mobile_number || addProviderDetails.mobile_number.trim() === "")) {
                                                                                    setToastErrorMessage("Master SMS Alert cannot be enabled without a mobile number")
                                                                                    return
                                                                                }
                                                                                setBlockSms(nextValue)
                                                                                setIsDisableCancel(false)
                                                                            }}
                                                                            checked={blockSms}
                                                                        />
                                                                        <span className="slider round"></span>
                                                                    </label>
                                                                    <p className="text-sm font-normal text-[#008586] disable_switch ml-3">
                                                                        SMS
                                                                    </p>
                                                                </div>
                                                                <div className="status custom-toggle flex items-center">
                                                                    <label className="switch" style={{marginLeft: '0px'}}>
                                                                        <input 
                                                                            type="checkbox" 
                                                                            onChange={(e) => {
                                                                                setBlockEmail(!blockEmail)
                                                                                setIsDisableCancel(false)
                                                                            }} 
                                                                            checked={blockEmail}
                                                                        />
                                                                        <span className="slider round"></span>
                                                                    </label>
                                                                    <p className="text-sm font-normal text-[#008586] disable_switch ml-3">
                                                                        Email
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                </>}
                                                <div className='w-1/3 px-[18px] mb-[35px]'>
                                                    <div className='w-full'>
                                                        <PhoneNumberValidator
                                                            label={"Mobile Number *"}
                                                            placeholder={"Enter Mobile Number"}
                                                            id={"mobile_number"}
                                                            data_testid={"mobile_number"}
                                                            htmlFor={"Provider_Mobile_Number"}
                                                            value={addProviderDetails.mobile_number}
                                                            emptyField={emptyField && addProviderDetails?.mobile_number?.trim() === ""}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                            isCode={true}
                                                            countryCodeList={phoneCodeArray}
                                                            country_code={country_code}
                                                            countryCodeVal={countryCodeVal}
                                                            isPhoneNumberValid={isPhoneNumberValid.mobile_number}
                                                            setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                            setCountryCodeVal={setCountryCodeVal}
                                                            submitSelected={submitSelected}
                                                        //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                                        />

                                                    </div>
                                                </div>
                                                <div className='w-1/3 px-[18px] mb-[35px]'>
                                                    <div className='w-full'>
                                                    
                                                        <PhoneNumberValidator
                                                            label={"Main Number*"} 
                                                            placeholder={"Enter Main Number"}
                                                            id={"main_number"}
                                                            data_testid={"main_number"}
                                                            htmlFor={"Provider_Main_Number"}
                                                            value={addProviderDetails.main_number}
                                                            emptyField={emptyField&&addProviderDetails?.main_number?.trim()===""}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                            isCode={true}
                                                            countryCodeList={phoneCodeArray}
                                                            country_code={country_code}
                                                            countryCodeVal={countryCodeVal2}
                                                            setCountryCodeVal={setCountryCodeVal2}
                                                            isPhoneNumberValid={isPhoneNumberValid.main_number}
                                                            setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                            submitSelected={submitSelected}
                                                            //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}

                                                        />
                                                    </div>
                                                </div>
                                                {edit && <div className='w-1/3 px-[18px] mb-[35px]'></div>}
                                                <div className='w-1/3 px-[18px] mb-[35px]'>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"NPI Number"}
                                                            placeholder={"Enter NPI number"}
                                                            id={"npi_number"}
                                                            data_testid={"npi_number"}
                                                            htmlFor={"provider_npi_number"}
                                                            value={addProviderDetails.npi_number}
                                                            emptyField={false}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />


                                                    </div>
                                                </div>
                                                <div className='w-1/3 px-[18px] mb-[35px]'>
                                                    <p className='text-sm font-semibold text-[#000000] pb-1.5'>Provider Credentials</p>
                                                    <div className='flex items-center'>
                                                        <div className="p-2">
                                                            <div className="relative custom-radioBlue flex items-center">
                                                                <input id="provider_credential" data_testid={"provider_credential"} type="radio" name="default-radio" checked={addProviderDetails?.provider_credential === "Physician"} onChange={() => { handleOnChangeUserDetails("provider_credential", "Physician") }} />
                                                                <label htmlFor="provider_credential" className="text-base font-normal text-[#000] pl-8 w-full cursor-pointer">
                                                                    Physician
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="p-2">
                                                            <div className="relative custom-radioBlue flex items-center" >
                                                                <input id="provider_credential1" data_testid={"provider_credential"} type="radio" name="default-radio" checked={addProviderDetails?.provider_credential === "Nurse"} onChange={() => { handleOnChangeUserDetails("provider_credential", "Nurse") }} />
                                                                <label htmlFor="provider_credential1" className="text-base font-normal text-[#000] pl-8 w-full cursor-pointer">
                                                                    Nurse
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* Add mode: show Block Active Alerts (OFF by default) */}
                                                {!edit && (
                                                    <div className='w-1/3 px-[18px] mb-[35px]'>
                                                        <div className='w-full'>
                                                            <p className='text-sm font-semibold text-[#000000] pb-1.5'>Block Active Alerts</p>
                                                            <div className='flex items-center gap-6 pt-2'>
                                                                <div className="status custom-toggle flex items-center">
                                                                    <label className="switch" style={{marginLeft: '0px'}}>
                                                                        <input
                                                                            type="checkbox"
                                                                            onChange={() => {
                                                                                const nextValue = !blockSms
                                                                                // Validation: can't allow SMS alerts (unblock) without a mobile number
                                                                                if (nextValue === false && (!addProviderDetails.mobile_number || addProviderDetails.mobile_number.trim() === "")) {
                                                                                    setToastErrorMessage("Master SMS Alert cannot be enabled without a mobile number")
                                                                                    return
                                                                                }
                                                                                setBlockSms(nextValue)
                                                                                setIsDisableCancel(false)
                                                                            }}
                                                                            checked={blockSms}
                                                                        />
                                                                        <span className="slider round"></span>
                                                                    </label>
                                                                    <p className="text-sm font-normal text-[#008586] disable_switch ml-3">SMS</p>
                                                                </div>
                                                                <div className="status custom-toggle flex items-center">
                                                                    <label className="switch" style={{marginLeft: '0px'}}>
                                                                        <input
                                                                            type="checkbox"
                                                                            onChange={() => {
                                                                                setBlockEmail(!blockEmail)
                                                                                setIsDisableCancel(false)
                                                                            }}
                                                                            checked={blockEmail}
                                                                        />
                                                                        <span className="slider round"></span>
                                                                    </label>
                                                                    <p className="text-sm font-normal text-[#008586] disable_switch ml-3">Email</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {edit&&<div className='w-1/3 px-[18px] mb-[35px] self-center'>
                                                    <div className='w-full pt-[16px]'>
                                                        <div className="status custom-toggle flex items-center ">
                                                            <p className="text-sm font-normal  text-[#000000] disable_switch  mr-4">
                                                                Status
                                                            </p> 
                                                            <label className="switch" style={{marginLeft: '10px'}}>
                                                                <input type="checkbox" id="user_status" onChange={(e)=>{
                                                                    setStatusToggle(!statusToggle),setConfirmationStateStatus(true)
                                                                }} checked={statusToggle} /><span className="slider round"></span>
                                                            </label>
                                                            <p id='status' className="text-sm font-normal  text-[#008586] disable_switch ml-3">
                                                                {statusToggle?'Active':'Inactive'}
                                                            </p> 
                                                        </div>
                                                    </div>
                                                </div> }
                                                <div className='w-full px-[18px] mb-[35px]'>
                                                    <div className='w-1/2'>
                                                        <TextArea label={'Address'}
                                                            htmlFor={'Provider_user_address'}
                                                            id={'address'}
                                                            data_testid={"address"}
                                                            value={addProviderDetails.address}
                                                            placeholder={'Enter Address'}
                                                            emptyField={false}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                    </div>
                                                </div>
                                                {/* billing contact */}
                                                <p className='text-[16px] w-full -mx-[18px] px-[36px] leading-normal font-semibold pb-[8px] text-[#000000]'>Billing Contact</p>
                                                <div className={`w-1/3 px-[18px] ${emailError.email_error ? 'mb-[2px]' : 'mb-[35px]'}`}>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"Contact Name"}
                                                            placeholder={"Enter contact name"}
                                                            id={"contact_name"}
                                                            data_testid={"contact_name"}
                                                            htmlFor={"Provider_Contact_name"}
                                                            value={addProviderDetails.contact_name}
                                                            emptyField={false}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='w-1/3 px-[18px] mb-[35px]'>
                                                    <div className='w-full'>
                                                    
                                                        <PhoneNumberValidator
                                                            label={"Phone Number"}
                                                            placeholder={"Enter Phone Number"}
                                                            id={"billing_mobile_number"}
                                                            data_testid={"billing_mobile_number"}
                                                            htmlFor={"Provider_Mobile_Number"}
                                                            value={addProviderDetails.billing_mobile_number}
                                                            emptyField={false}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                            isCode={true}
                                                            countryCodeList={phoneCodeArray}
                                                            country_code={country_code}
                                                            countryCodeVal={countryCodeVal3}
                                                            isPhoneNumberValid={isPhoneNumberValid.billing_mobile_number}
                                                            setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                            setCountryCodeVal={setCountryCodeVal3}
                                                            submitSelected={submitSelected}
                                                        //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='w-1/3 px-[18px] mb-[35px]'>
                                                    <div className='w-full'>
                                                        <PhoneNumberValidator
                                                            label={"Fax"}
                                                            placeholder={"Enter Fax"}
                                                            id={"fax"}
                                                            data_testid={"fax"}
                                                            htmlFor={"Provider_Fax"}
                                                            value={addProviderDetails.fax}
                                                            emptyField={false}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                            isCode={true}
                                                            countryCodeList={phoneCodeArray}
                                                            country_code={country_code}
                                                            countryCodeVal={countryCodeVal4}
                                                            isPhoneNumberValid={isPhoneNumberValid.fax}
                                                            setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                            setCountryCodeVal={setCountryCodeVal4}
                                                            submitSelected={submitSelected}
                                                        //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={`w-1/3 px-[18px] ${emailError.billing_email_error ? 'mb-[2px]' : 'mb-[35px]'}`}>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"Email Address"}
                                                            placeholder={"Enter Email Address"}
                                                            id={"billing_email_address"}
                                                            data_testid={"billing_email_address"}
                                                            htmlFor={"Provider_Email_Address"}
                                                            emailError={emailError.billing_email_error}
                                                            value={addProviderDetails.billing_email_address}
                                                            emptyField={false}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                        {emailError.billing_email_error && <ErrorMessage error message={"Invalid email address"} />}
                                                    </div>
                                                </div>
                                           
                                            </div>
                                            {edit && <>
                                                <ProviderPatientList 
                                                    user_id={data?.user_id}
                                                    providerData={data}
                                                    patientAssociatedTrigger={patientAssociatedTrigger}
                                                    data={patientAssociatedResult?.data}
                                                    isFetching={patientAssociatedResult?.isFetching}
                                                    status={patientAssociatedResult?.status}
                                                    changeProviderAccess={changeProviderAccess}
                                                    setChangeProviderAccess={setChangeProviderAccess}
                                                    billingAgent={billingAgent}
                                                    setBillingAgent={setBillingAgent}
                                                    sendAlert={sendAlert}
                                                    setIsProviderAddOrDelete={setIsProviderAddOrDelete}
                                                    setSendAlert={setSendAlert}
                                                    setIsAnyFieldFilled={setIsAnyFieldFilled}
                                                    handleDeleteAssociatedPatient={handleDeleteAssociatedPatient}
                                                    fetchPageAndLimit={fetchPageAndLimitPat}
                                                    queryParams={queryParams}
                                                    setQueryParams={setQueryParams}
                                                    pageItems={pageItems}
                                                    setPageItems={setPageItems}
                                                />
                                                <ProviderOrganizationAssocaition 
                                                    organizationData={organizationData}
                                                    organizationFetching={organizationFetching}
                                                    handleOrganizationListSearch={handleOrganizationListSearch}
                                                    organizationListSearch={organizationListSearch}
                                                    handleFetchSubdivision={handleFetchSubdivision}
                                                    subdivisionData={subresult.data}
                                                    handleSubdivisionListSearch={handleSubdivisionListSearch}
                                                    selectedOrganizationName={selectedOrganizationName}
                                                    handleAddAssociation={handleAddAssociation}
                                                    associatedOrganizations={result?.data}
                                                    selectedSubdivisionName={selectedSubdivisionName}
                                                    isOpen={isOpen}
                                                    setisOpen={setisOpen}
                                                    setisOpensub={setisOpensub}
                                                    isOpensub={isOpensub}
                                                    limit={limit}
                                                    setLimit={setLimit}
                                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                                    isColumnSelect={isColumnSelect}
                                                    setIsColumnSelect={setIsColumnSelect}
                                                    isOpenLimit={isOpenLimit}
                                                    setIsOpenLimit={setIsOpenLimit}
                                                    handlePrevClick={handlePrevClick}
                                                    handleNextClick={handleNextClick}
                                                    fetchPageAndLimit={fetchPageAndLimit}
                                                    totalPageNumber={totalPageNumber}
                                                    result={result}
                                                    setSelectedSubdivisionName={setSelectedSubdivisionName}
                                                    isSideBar={isSideBar}
                                                    handleDeleteAssociatedOrganization={handleDeleteAssociatedOrganization}
                                                    setLinkOrganizationModel={setLinkOrganizationModel}
                                                    handleSelectionSubdivision={handleSelectionSubdivision}
                                                    setSelectedOrganizationName={setSelectedOrganizationName}
                                                    subdivisionloadingstatus={subresult}
                                                    lastPromiseinfo={lastPromiseinfo}
                                                    setOrgDetails={setOrgDetails}
                                            
                                                />
                                            </>
                                            }
                                        </div>                                  
                                    </div>
                                    <div className='flex justify-end pr-5'>
                                        {/* <p className='ml-10 xl:w-auto w-[280px] tl:w-[400px]  '>{emptyField && addProviderDetails?.email_address?.trim() === "" && addProviderDetails?.mobile_number?.trim() === "" && <ErrorMessage error message={"Please fill in either an email address or a mobile number. One of these is mandatory."} />}</p> */}
                                        <div>
                                            <button type='button'
                                                id="cancel"
                                                onClick={() => handleCancelBottom()}
                                                className={` px-4 py-2.5 mr-5 text-lg font-semibold  text-[#972E4C] border border-[#972E4C] rounded-[16px] mt-2.5 xl:w-[148px] w-[130px]
                                            bg-[#fff] hover:bg-[#fff] focus:bg-[#fff]`}>
                                                {"Cancel"}
                                            </button>
                                            <button type='button'
                                                id="update"
                                                data-testid="add-provider-btn"
                                                onClick={handleSubmit}
                                                className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 xl:w-[148px] w-[130px]
                                            bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                                {`${edit ? 'Update' : 'Submit'}`}

                                            </button>
                                        </div>

                                    </div>
                                </>}
                            </div>
                        </motion.div>
                    </div>
                    
                </>}
                {confirmationState &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                handleOnCLickActivate={handleOnAddUser}
                                handleClose={handleConformationClick}
                                data-testid="confirm-btn"
                                disabled={loading}
                                tittle={`${edit ? 'Update' : 'Add Provider'}`}
                                message={`Are you sure you want to  ${edit ? 'update' : 'add'} this provider?`}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                                CancelButton={'No'}

                            />
                        }
                    />
                }
                {confirmationStateCancel &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                handleOnCLickActivate={handleCancel}
                                handleClose={handleConformationClickCancel}
                                tittle={'Cancel'}
                                message={`Are you sure you want to cancel the changes?`}
                                buttonName={true && 'Yes'}
                                CancelButton={'No'}
                            />
                        }
                    />
                }
                {deleteModel &&
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleConfirmDelete}
                            handleClose={handleCloseDeleteModal}
                            tittle={'Remove'}
                            message={`Are you sure you want to remove the organization?`}
                            buttonName={"Confirm"}
                            loadingActivation={deleteLoading}
                            // CancelButton={"No"}
                            disabled={deleteLoading}
                        />
                    }
                />}
                {linkOrganizationModel &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                handleOnCLickActivate={handleAddAssociation}
                                handleClose={handleCloseLinkModel}
                                tittle={'Link Organization'}
                                message={`Are you sure you want to link the organization and sub division?`}
                                buttonName={"Yes"}
                                loadingActivation={deleteLoading}
                                CancelButton={"No"}
                                disabled={deleteLoading}
                            />
                        }
                    />}

                {confirmationStateStatus && 
                <AnimatedModel 
                    Children={
                        <ConfirmationPrompt
                            emptyField={emptyArea}
                            setEmptyField={setEmptyArea}
                            setTextAreaMsg={setTextAreaMsg}
                            textAreaMsg={textAreaMsg}
                            disabled={loadingStatus}
                            loadingActivation={loadingStatus}
                            handleOnCLickActivate={handleOnCLickChangeStatus}
                            handleClose={handleConformationClickStatus}
                            tittle= {statusToggle?'Activate':'Deactivate'}
                            message = {`Are you sure you want to ${statusToggle? 'activate' : 'deactivate'} this provider?`}
                            textMessage = {statusToggle===false?false:true}
                            buttonName = {statusToggle?'Activate':'Deactivate'}
                        />
                    }
                /> 
                }
                {isProviderAddOrDelete &&
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleConfirmPatientDelete}
                            handleClose={handleClosePatientDeleteModal}
                            tittle={'Remove'}
                            message={`Are you sure you want to remove the patient?`}
                            buttonName={"Confirm"}
                            loadingActivation={deleteLoading}
                            // CancelButton={"No"}
                            disabled={deleteLoading}
                        />
                    }
                />}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }


            </div>
        </>
    )
}
export default AddProvider